
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.73 19.33L13.73 2a2 2 0 00-3.46 0l-10 17.33a2 2 0 001.73 3h20a2 2 0 001.73-3zM12 19.67a1.34 1.34 0 111.33-1.34A1.33 1.33 0 0112 19.67zm1.59-9.94l-.53 5.34a.66.66 0 01-.66.6h-.8a.67.67 0 01-.66-.6l-.53-5.34a.67.67 0 01.66-.73h1.86a.67.67 0 01.66.73z","fill":"#f43040"}}),_c('path',{attrs:{"d":"M12.93 9h-1.86a.67.67 0 00-.66.73l.53 5.34a.66.66 0 00.66.6h.8a.67.67 0 00.66-.6l.53-5.34a.67.67 0 00-.66-.73zM12 17a1.34 1.34 0 101.33 1.33A1.33 1.33 0 0012 17z","fill":"#fff","fill-opacity":".87"}})])
          )
        }
      }
    